"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HKDelayRoleTip = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/**
 * 港股延时tip
 */
function HKDelayRoleTip(props) {
    var _a, _b;
    if (!props.tiptxt)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var wid = (_a = props.width) !== null && _a !== void 0 ? _a : 300, mt = (_b = props === null || props === void 0 ? void 0 : props.mt) !== null && _b !== void 0 ? _b : 0;
    return (react_1.default.createElement("span", { className: "ggtips", style: { marginTop: mt + 'px' } },
        react_1.default.createElement("span", { className: "hkruletip" }),
        react_1.default.createElement("span", { className: "txt", style: { width: wid + 'px' }, dangerouslySetInnerHTML: { __html: props.tiptxt } })));
}
exports.HKDelayRoleTip = HKDelayRoleTip;
